import type { Family } from "components/userModel";

export default function useCanShowField(
  applicantName: string,
  applicantNameKana: string,
  birthDate: string,
  age: number,
  homePostalCode: string,
  homePrefecture: string,
  homeCity: string,
  homeAddress1: string,
  _homeAddress2: string,
  _homePhoneNumber: string,
  mobileNumber: string,
  _companyName: string,
  _invoiceNumber: string,
  _corporateNumber: string,
  postalCode: string,
  prefecture: string,
  city: string,
  address1: string,
  _address2: string,
  phoneNumber: string,
  _faxNumber: string,
  industryType: string,
  annualSales: string,
  employeeCount: string,
  _taxDelayType: string,
  _taxDelayBalance: number,
  _taxDelayStatus: string,
  familyStructure: Family[],
  factoringHistory: string,
  pastProviders: string,
  pastProviderAmount: number,
  currentProviderHistory: string,
  currentProviders: string,
  currentProviderAmount: number,
  personalInfoConsent: boolean,
  uploadedFiles: File[],
) {
  return (fieldName: string): boolean => {
    if (fieldName === 'applicantName') return true;

    let result = true;

    result &&= !!applicantName;
    if (fieldName === 'applicantNameKana') return result;

    result &&= !!applicantNameKana;
    if (fieldName === 'birthDate') return result;

    result &&= !!birthDate;
    if (fieldName === 'age') return result;

    result &&= age >= 0;
    if (fieldName === 'homePostalCode') return result;

    result &&= !!homePostalCode;
    if (fieldName === 'homePrefecture') return result;

    result &&= !!homePrefecture;
    if (fieldName === 'homeCity') return result;

    result &&= !!homeCity;
    if (fieldName === 'homeAddress1') return result;

    result &&= !!homeAddress1;
    if (fieldName === 'homeAddress2') return result;
    if (fieldName === 'homePhoneNumber') return result;
    if (fieldName === 'mobileNumber') return result;

    result &&= !!mobileNumber;
    if (fieldName === 'companyName') return result;
    if (fieldName === 'postalCode') return result;
    if (fieldName === 'invoiceNumber') return result;
    if (fieldName === 'corporateNumber') return result;

    result &&= !!postalCode;
    if (fieldName === 'prefecture') return result;

    result &&= !!prefecture;
    if (fieldName === 'city') return result;

    result &&= !!city;
    if (fieldName === 'address1') return result;
    if (fieldName === 'address2') return result;

    result &&= !!address1;
    if (fieldName === 'phoneNumber') return result;
    if (fieldName === 'faxNumber') return result;

    result &&= !!phoneNumber;
    if (fieldName === 'industryType') return result;

    result &&= !!industryType;
    if (fieldName === 'annualSales') return result;

    result &&= !!annualSales;
    if (fieldName === 'employeeCount') return result;

    result &&= !!employeeCount;
    if (fieldName === 'familyStructure') return result;

    const isValidFamily = familyStructure.length >= 0 && familyStructure.every(
      (member) =>
        !!member.relationship &&
        !!member.fullName &&
        member.age >= 0 &&
        !!member.contactInfo
    );
    result &&= isValidFamily;
    if (fieldName === 'factoringHistory') return result;

    if (result && factoringHistory === "あり") {
      if (fieldName === 'pastProviders') return result;
      result &&= !!pastProviders;

      if (fieldName === 'pastProviderAmount') return result;
      result &&= pastProviderAmount >= 0;

      if (fieldName === 'currentProviderHistory') return result;
      result &&= !!currentProviderHistory;

      if (currentProviderHistory === "あり") {
        if (fieldName === 'currentProviders') return result;
        result &&= !!currentProviders;
        if (fieldName === 'currentProviderAmount') return result;
        result &&= currentProviderAmount >= 0;
      }
    } else {
      if (fieldName === 'pastProviders' ||
        fieldName === 'pastProviderAmount' ||
        fieldName === 'currentProviderHistory' ||
        fieldName === 'currentProviders' ||
        fieldName === 'currentProviderAmount') {
        return false;
      }
    }


    if (fieldName === 'fileUpload') return result;

    result &&= uploadedFiles.length > 0;
    if (fieldName === 'personalInfoConsent') return result;

    result &&= personalInfoConsent;
    if (fieldName === 'submitButton') return result;

    return false;
  };
};
